import React from 'react';
import './TrackingModal.css';

function TrackingModal({ report, onClose }) {
  if (!report) return null;

  const milestones = [
    { 
      id: 'submitted', 
      label: 'Request Submitted', 
      desc: 'Case successfully initialized in Origin Core.',
      icon: 'fa-solid fa-paper-plane'
    },
    { 
      id: 'reviewing', 
      label: 'Security Audit', 
      desc: 'Administrators are auditing your developer footprint.',
      icon: 'fa-solid fa-user-shield'
    },
    { 
      id: 'processing', 
      label: 'Moderation Execution', 
      desc: 'Governance protocols are being applied to your ID.',
      icon: 'fa-solid fa-gears'
    },
    { 
      id: 'resolved', 
      label: 'Case Finalized', 
      desc: 'Resolution complete. System cache synchronized.',
      icon: 'fa-solid fa-circle-check'
    }
  ];

  // Map database status to milestone index
  const getStatusIndex = (status) => {
    const s = status?.toLowerCase();
    if (s === 'resolved' || s === 'completed' || s === 'approved') return 3;
    if (s === 'processing') return 2;
    if (s === 'reviewing' || s === 'under review') return 1;
    if (s === 'rejected' || s === 'cancelled') return -1; // Special case for termination
    return 0; // open/submitted
  };

  const currentIndex = getStatusIndex(report.status);
  const isRejected = currentIndex === -1;

  return (
    <div className="tracking-modal-overlay" onClick={onClose}>
      <div className="tracking-modal-card glass-card animate-up" onClick={e => e.stopPropagation()}>
        <header className="tracking-header">
          <div className="tracking-id-strip">
            <span>OFFICIAL GOVERNANCE CASE</span>
            <strong>{report.reportId}</strong>
          </div>
          <button className="close-tracking" onClick={onClose}>
            <i className="fa-solid fa-xmark"></i>
          </button>
        </header>

        <div className="tracking-body">
          <div className="case-meta-header">
            <h3>{report.subject}</h3>
            <div className="case-category">
              <i className="fa-solid fa-layer-group"></i>
              {report.category}
            </div>
          </div>

          <div className="timeline-container">
            {milestones.map((step, idx) => {
              const isPast = idx < currentIndex;
              const isCurrent = idx === currentIndex;
              const isFuture = idx > currentIndex && !isRejected;

              return (
                <div key={idx} className={`timeline-step ${isPast ? 'past' : ''} ${isCurrent ? 'current' : ''} ${isFuture ? 'future' : ''} ${isRejected && idx === 1 ? 'rejected-step' : ''}`}>
                  <div className="step-indicator">
                    <div className="step-icon">
                      <i className={isRejected && idx === 1 ? 'fa-solid fa-circle-xmark' : step.icon}></i>
                    </div>
                    {idx < milestones.length - 1 && <div className="step-connector"></div>}
                  </div>
                  <div className="step-content">
                    <h4>{isRejected && idx === 1 ? 'Review Rejected' : step.label}</h4>
                    <p>{isRejected && idx === 1 ? (report.reason || "The request did not meet platform security criteria.") : step.desc}</p>
                    {isCurrent && (
                      <div className="live-pulse">
                        <div className="pulse-dot"></div>
                        <span>Live Activity Signal</span>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {isRejected && (
            <div className="rejection-notice">
              <i className="fa-solid fa-triangle-exclamation"></i>
              <div>
                <strong>Identity Integrity Conflict</strong>
                <p>Origin Core has blocked this request. Credits have been restored where applicable.</p>
              </div>
            </div>
          )}
        </div>

        <footer className="tracking-footer">
          <div className="tracking-timestamp">
            <i className="fa-solid fa-clock-rotate-left"></i>
            Last Activity: {new Date(report.updatedAt || report.createdAt).toLocaleString()}
          </div>
          <p className="tracking-disclaimer">Authenticated log by Origin Core AI-Moderation Layer.</p>
        </footer>
      </div>
    </div>
  );
}

export default TrackingModal;
